import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getPurchaseReport } from '../../app/store/actions/report';
import HeaderComponent from '../../components/table/header/headerComponent';
import translationOfErrors from '../../helpers/translationOfErrors';
import ModernDatepicker from 'react-modern-datepicker';

class PurchaseReportPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      initialDate: moment(new Date(), 'DD-MM-YYYY'),
      finalDate: moment(new Date(), 'DD-MM-YYYY'),
      warningColor: '',
      warning: '',
    };
  }

  getAccessLoginReport = async () => {
    const { initialDate, finalDate } = this.state;

    try {
      const response = await this.props.getPurchaseReport(moment(initialDate).format(), moment(finalDate).format());
      if (response) {
        await this.setState({
          warning: I18n.t('reportGeneratedSuccessfully'),
          warningColor: 'green',
        });
      } else {
        await this.setState({
          warning: I18n.t('dataNotFound'),
          warningColor: 'red',
        });
      }
    } catch (error) {
      const validError = !!error.response && error.response.data && error.response.data.error;
      const errorCode = (validError) ? error.response.data.error.code : null

      const warning = (errorCode)
        ? I18n.t(translationOfErrors[errorCode] || 'unknownError')
        : I18n.t('unknownError');

      await this.setState({
        warning,
        warningColor: 'red',
      });
    }
  }

  render() {
    const {
      initialDate, finalDate, warning, warningColor,
    } = this.state;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent title={I18n.t('purchaseReport')} />
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group form-promotion-picker">
                <p className="margin-bottom-2">{I18n.t('initialDate')}</p>
                <div className="inputs">
                  <ModernDatepicker
                    className="form-control"
                    showBorder
                    placeholder=""
                    format="DD/MM/YYYY"
                    date={initialDate}
                    onChange={date => this.setState({ initialDate: moment(date, 'DD-MM-YYYY') })}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group form-promotion-picker">
                <p className="margin-bottom-2">{I18n.t('finalDate')}</p>
                <div className="inputs">
                  <ModernDatepicker
                    className="form-control"
                    showBorder
                    placeholder=""
                    format="DD/MM/YYYY"
                    date={finalDate}
                    onChange={date => this.setState({ finalDate: moment(date, 'DD-MM-YYYY') })}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="btn-group" role="group" aria-label='Gerar Relatório'>
            <button
              className="btn btn-primary"
              type="button"
              onClick={this.getAccessLoginReport}
            >
              {I18n.t('generateReport')}
            </button>
          </div>
        </div>
        {warning && (
          <p style={{ color: `${warningColor}`, margin: '25px 0 0 0' }}>
            {warning}
          </p>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  getPurchaseReport: (initialDate, finalDate) => dispatch(getPurchaseReport(initialDate, finalDate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseReportPage);